// extracted by mini-css-extract-plugin
module.exports = {"numbers":"AboutSectionNumbers-module_numbers_6cf1e","numbersButton":"AboutSectionNumbers-module_numbersButton_c8e31"};